import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-notifications-component/dist/theme.css";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import App from "./App";
// import MobileAppScreen from "./app/components/MobileAppScreen";
import reportWebVitals from "./reportWebVitals";
import AwsContextProvider from "./app/awscontext";
import PreSystemCheck from "./app/components/pre-system-check-steps/PreSystemCheck";
import "./config/lotec.css";

ReactDOM.render(
  <AwsContextProvider>
    <BrowserRouter forceRefresh={true}>
      <Switch>
        {/* <Route
          path="/mobile"
          render={(props) => <MobileAppScreen {...props} />}
        /> */}
        <Route
          path="/preExamSystemCheck"
          render={(props) => <PreSystemCheck {...props} />}
        />
        <Route path="/lockdownBrowser" render={(props) => <App {...props} />} />
        <Route path="/" render={(props) => <App {...props} />} />
      </Switch>
    </BrowserRouter>
  </AwsContextProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
